import { Link } from "react-router-dom";
import styles from "./CaseStudyCard.module.css";

export default function CaseStudyCard({ caseStudy }) {
  if (!caseStudy) {
    return null;
  }

  return (
    <Link
      to={`/case-studies/${caseStudy.slug}`}
      className={styles.card}
      aria-label={caseStudy.title}
    >
      <div className={styles.content}>
        <div className={styles.imageWrap}>
          <img
            src={caseStudy.image}
            alt={caseStudy.title}
            className={styles.image}
          />
        </div>
        <h3 className={styles.title}>{caseStudy.title}</h3>
        <p className={styles.description}>{caseStudy.excerpt}</p>
      </div>
    </Link>
  );
}
